import { Agent, AgentPermission } from "~/services/agents";

// Deleting an agent maps to the manager-only `can_delete` grant, resolved
// per-agent by the API; editors, USER-level grants, and SYSTEM agents never
// confer it. Distinct from editing (`can_edit`), which editors also hold.
export const useCanDeleteAgent = (agent: Agent | undefined): boolean =>
  !!agent && agent.permissions.includes(AgentPermission.CAN_DELETE);
